import React from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from 'components';

export default (props: { children?: React.ReactNode }) => (
  <React.Fragment>
    <div className="layout">
      <div className="layout-main">
        <NavMenu />
        <Container fluid={true}>{props.children}</Container>
      </div>
    </div>
  </React.Fragment>
);
